import script from "./dol-button.vue?vue&type=script&lang=js"
export * from "./dol-button.vue?vue&type=script&lang=js"

import "./dol-button.vue?vue&type=style&index=0&id=9731820a&lang=scss"

const __exports__ = script;

export default __exports__